<template>
  <!-- 出单详情弹框 -->
  <Modal v-model="visible" width="1200px" :title="title" :mask-closable="false" :footer-hide="true" class="my-modal top detail p-b">
    <!-- needSignup 1:业务员报名参与 0：自动参与 -->
    <Tabs v-model="tabName" :animated="false" @on-click="changeTabs" v-if="rowData.needSignup == '1'">
      <TabPane label="参与详情" name="1">
        <div class="content">
          <div class="search-box btn3">
            <div class="input-item">
              <span class="label">保单号</span>
              <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
              <span class="label">产品名称</span>
              <Input v-model="searchParams.productName" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
              <span class="label">险种名称</span>
              <Input v-model="searchParams.additionName" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
              <span class="label">保单状态</span>
              <Select v-model="searchParams.status" filterable clearable>
                <Option value="1">已承保</Option>
                <Option value="-1">已退保</Option>
                <Option value="0">已终止</Option>
              </Select>
            </div>
            <div class="input-item select-two">
              <Select v-model="searchParams.name" :transfer="true">
                <Option value="salesmanName">业务员姓名</Option>
                <Option value="staffNo">业务员工号</Option>
              </Select>
              <Input v-model="searchParams.nameValue" placeholder="请输入" clearable />
            </div>
            <div class="input-item select-two" v-if="![3, 6].includes(rowData.conditionalIndicator * 1) || rowData.endorsementIsJoin != 1 || productType != 2">
              <Select v-model="searchParams.timeName" :transfer="true">
                <Option value="startTime">生效日期</Option>
                <Option value="insureTime">承保日期</Option>
              </Select>
              <DatePicker
                type="daterange"
                split-panels
                separator="至"
                :transfer="true"
                placement="bottom"
                v-model="searchParams.timeValue"
                placeholder="选择日期"
              ></DatePicker>
            </div>
            <div class="input-item">
              <span class="label">出单团队/机构</span>
              <selectTree type="2" @change="changeOrg" v-model="searchParams.orgId" :isAll="true"></selectTree>
            </div>
            <template v-if="formData.productType == 1">
              <div class="input-item">
                <span class="label">回执状态</span>
                <lzDicSelect
                  v-model="searchParams.receiptStatusList"
                  dicType="RECEIPT_STATUS"
                  :transfer="true"
                  clearable
                  multiple
                  :disabled="searchParams.receiptStatusNull"
                >
                </lzDicSelect>
                <Checkbox v-model="searchParams.receiptStatusNull" class="null-radio">为空</Checkbox>
              </div>
              <div class="input-item">
                <span class="label">回访状态</span>
                <lzDicSelect
                  v-model="searchParams.verifyStatusList"
                  dicType="VERIFY_STATUS"
                  :transfer="true"
                  clearable
                  multiple
                  :disabled="searchParams.verifyStatusNull"
                >
                </lzDicSelect>
                <Checkbox v-model="searchParams.verifyStatusNull" class="null-radio">为空</Checkbox>
              </div>
              <div class="input-item">
                <span class="label">是否自保件</span>
                <RadioGroup v-model="searchParams.isSelfHold" @on-change="searchAjax()">
                  <Radio label="">全部</Radio>
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">是否互保件</span>
                <RadioGroup v-model="searchParams.isMutualHold" @on-change="searchAjax()">
                  <Radio label="">全部</Radio>
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </div>
              <div class="input-item">
                <span class="label">质检状态</span>
                <Select v-model="searchParams.confirmRightStatusIn" :transfer="true" clearable multiple>
                  <Option value="0">待单录</Option>
                  <Option value="1">待质检</Option>
                  <Option value="2">质检成功</Option>
                  <Option value="-1">质检失败</Option>
                </Select>
              </div>
              <div class="input-item">
                <span class="label">犹豫止期</span>
                <DatePicker
                  v-model="searchParams.hesitateDate"
                  type="daterange"
                  @on-change="changeHesitateDate"
                  split-panels
                  separator=" 至 "
                  :transfer="true"
                  placement="bottom"
                  format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></DatePicker>
              </div>
            </template>
            <div class="btn-item">
              <Button class="btn-item__item" type="primary" @click="searchAjax(), (listLoading = false)">查询</Button>
              <Button class="btn-item__item" type="primary" ghost @click="resetSearch(), (formData.receiptVerifyStatus = '')">重置</Button>
              <Button class="btn-item__item" type="warning" @click="daochu()">导出</Button>
              <!-- <detailAddPolicy class="btn-item__item" /> -->
            </div>
          </div>

          <div class="statistics" style="margin-bottom: 15px" v-if="[3, 6].includes(rowData.conditionalIndicator * 1)">
            共计保单<strong>{{ statistics.policyNum }}</strong
            >单 ，规模保费为<strong>{{ statistics.feeSum }}</strong
            >元，标准保费为<strong>{{ statistics.foldFybSum }}</strong
            >元<span v-if="rowData.rewardType != 3"
              >，预计活动服务费为<strong>{{ statistics.rewardPriceSum }}</strong
              >元</span
            >
          </div>
          <div class="table-box">
            <loading :isShow="listLoading" />
            <Table :columns="filterColumns()" :data="tableData" row-key="id" :indent-size="0">
              <template slot-scope="{ row }" slot="userName_staffNo">
                <div class="name-status">
                  <div class="user-box">
                    <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
                    <span class="user-name">{{ row.staffNo }}/{{ row.salesmanName }}</span>
                  </div>
                </div>
              </template>

              <template slot-scope="{ row }" slot="additionName">
                <div class="addition-name">
                  <span class="fu" v-if="row.additionName && !row.children">附</span>
                  <span>{{ row.additionName ? row.additionName : '-' }}</span>
                </div>
              </template>
            </Table>
            <div class="pageBox">
              <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
            </div>
          </div>
        </div>
      </TabPane>

      <TabPane label="报名详情" name="3" v-if="rowData.needSignup == '1'">
        <enrollDetail ref="enroll" :actId="rowData.id"></enrollDetail>
      </TabPane>
    </Tabs>

    <div class="content" v-else style="margin-top: 10px">
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">险种名称</span>
          <Input v-model="searchParams.additionName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select v-model="searchParams.status" filterable clearable transfer>
            <Option value="1">已承保</Option>
            <Option value="-1">已退保</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.name" :transfer="true">
            <Option value="salesmanName">业务员姓名</Option>
            <Option value="staffNo">业务员工号</Option>
          </Select>
          <Input v-model="searchParams.nameValue" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two" v-if="![3, 6].includes(rowData.conditionalIndicator * 1) || rowData.endorsementIsJoin != 1 || productType != 2">
          <Select v-model="searchParams.timeName" :transfer="true">
            <Option value="startTime">生效日期</Option>
            <Option value="insureTime">承保日期</Option>
          </Select>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="searchParams.timeValue"
            placeholder="选择日期"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">出单团队/机构</span>
          <selectTree type="2" @change="changeOrg" v-model="searchParams.orgId" :isAll="true"></selectTree>
        </div>
        <template v-if="formData.productType == 1">
          <div class="input-item">
            <span class="label">回执状态</span>
            <lzDicSelect
              v-model="searchParams.receiptStatusList"
              dicType="RECEIPT_STATUS"
              :transfer="true"
              clearable
              multiple
              :disabled="searchParams.receiptStatusNull"
            >
            </lzDicSelect>
            <Checkbox v-model="searchParams.receiptStatusNull" class="null-radio">为空</Checkbox>
          </div>
          <div class="input-item">
            <span class="label">回访状态</span>
            <lzDicSelect
              v-model="searchParams.verifyStatusList"
              dicType="VERIFY_STATUS"
              :transfer="true"
              clearable
              multiple
              :disabled="searchParams.verifyStatusNull"
            >
            </lzDicSelect>
            <Checkbox v-model="searchParams.verifyStatusNull" class="null-radio">为空</Checkbox>
          </div>
          <div class="input-item">
            <span class="label">是否自保件</span>
            <RadioGroup v-model="searchParams.isSelfHold" @on-change="searchAjax()">
              <Radio label="">全部</Radio>
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </div>
          <div class="input-item">
            <span class="label">是否互保件</span>
            <RadioGroup v-model="searchParams.isMutualHold" @on-change="searchAjax()">
              <Radio label="">全部</Radio>
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </div>
          <div class="input-item">
            <span class="label">质检状态</span>
            <Select v-model="searchParams.confirmRightStatusIn" :transfer="true" clearable multiple>
              <Option value="0">待单录</Option>
              <Option value="1">待质检</Option>
              <Option value="2">质检成功</Option>
              <Option value="-1">质检失败</Option>
            </Select>
          </div>
          <div class="input-item">
            <span class="label">犹豫止期</span>
            <DatePicker
              v-model="searchParams.hesitateDate"
              type="daterange"
              @on-change="changeHesitateDate"
              split-panels
              separator=" 至 "
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
            ></DatePicker>
          </div>
        </template>
        <div class="btn-item">
          <Button class="btn-item__item" type="primary" @click="searchAjax()">查询</Button>
          <Button class="btn-item__item" type="primary" ghost @click="resetSearch(), (formData.receiptVerifyStatus = '')">重置</Button>
          <Button class="btn-item__item" type="warning" @click="daochu()">导出</Button>
          <!-- <detailAddPolicy class="btn-item__item" /> -->
        </div>
      </div>
      <div class="statistics" style="margin-bottom: 15px">
        共计保单<strong>{{ statistics.policyNum }}</strong
        >单 ，规模保费为<strong>{{ statistics.feeSum }}</strong
        >元，标准保费为<strong>{{ statistics.foldFybSum }}</strong
        >元<span v-if="rowData.rewardType != 3"
          >，预计活动服务费为<strong>{{ statistics.rewardPriceSum }}</strong
          >元</span
        >
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="filterColumns()" :data="tableData" row-key="uniqueKey" :indent-size="0">
          <template slot-scope="{ row }" slot="userName_staffNo">
            <div class="name-status">
              <div class="user-box">
                <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
                <span class="user-name">{{ row.staffNo }}/{{ row.salesmanName }}</span>
              </div>
            </div>
          </template>

          <template slot-scope="{ row }" slot="settlementStatus">
            <div class="settlement-status">
              <span v-if="row.releaseStatus == '0'" class="tag-settled">未结算</span>
              <span v-else class="tag-be">已结算</span>
            </div>
          </template>

          <template slot-scope="{ row }" slot="additionName">
            <div class="addition-name">
              <span class="fu" v-if="row.additionName && !row.children">附</span>
              <span>{{ row.additionName ? row.additionName : '-' }}</span>
            </div>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import lzDicSelect from '@/components/commons/lzDicSelect';
import editor from '@/components/commons/editor';
import upLoadNew from '@/components/commons/uploadNew';
import selectTree from '@/components/system/selectTree3';
import enrollDetail from './enrollDetail';
import { pageTool } from '@/api/mixins';
import { filterTime } from '@/api/filter';
import { common } from '@/api/mixins';
// import detailAddPolicy from './detailAddPolicy.vue';
export default {
  mixins: [pageTool, common],
  components: {
    editor,
    upLoadNew,
    selectTree,
    lzDicSelect,
    enrollDetail,
    // detailAddPolicy
  },
  data() {
    return {
      dic: JSON.parse(localStorage.dic),
      visible: false,
      tabName: '1',
      formData: {},
      nodeType: '',
      statistics: {},
      columns: [],
      rowData: {},
      title: ''
    };
  },
  methods: {
    open(data) {
      this.listLoading = false;
      this.tabName = '1';
      this.title = `${data.name}-详情`;
      this.rowData = data;
      this.searchParams = {};
      this.columns = [
        {
          title: '保单号',
          key: 'policyNo',
          align: 'left',
          width: '220',
          tree: true,
          fixed: 'left',
          render(h, params) {
            return <span>{params.row.policyNo ? params.row.policyNo : '-'}</span>;
          }
        },
        {
          title: '批单号',
          key: 'billNo',
          align: 'center',
          width: '200',
          fixed: 'left',
          render(h, params) {
            return <span>{params.row.billNo ? params.row.billNo : '-'}</span>;
          }
        },
        {
          title: '出单业务员',
          key: 'salesmanName',
          align: 'center',
          width: '220',
          fixed: 'left',
          slot: 'userName_staffNo'
        },
        {
          title: '规模保费',
          key: 'fee',
          align: 'center',
          width: '100'
        },
        {
          title: '标准保费',
          key: 'foldFyb',
          align: 'center',
          width: '100'
        },
        {
          title: '出单服务费',
          key: 'commissionPrice',
          align: 'center',
          width: '100'
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          width: '200'
        },
        {
          title: '险种名称',
          key: 'additionName',
          align: 'center',
          width: '200',
          slot: 'additionName'
          // render(h, params) {
          //   return <span>{params.row.additionName ? params.row.additionName : '-'}</span>;
          // }
        },
        {
          title: '交费期',
          key: 'payLimit',
          align: 'center',
          render(h, params) {
            return <span>{params.row.payLimit ? params.row.payLimit + '年' : ''}</span>;
          },
          width: '100'
        },
        {
          title: '保障期',
          key: 'guaranteeLimit',
          align: 'center',
          width: '100',
          render(h, item) {
            const type = item.row.guaranteeType;
            let res = '';
            if (type == 1) {
              res = '保终身';
            } else if (type == 2) {
              res = `保${item.row.guaranteeLimit}岁`;
            } else if (type == 3) {
              res = `保${item.row.guaranteeLimit}年`;
            } else if (type == 4) {
              res = `保${item.row.guaranteeLimit}个月`;
            } else if (type == 5) {
              res = `保${item.row.guaranteeLimit}天`;
            }
            return <span>{res}</span>;
          }
        },
        {
          title: '出单机构/团队',
          key: 'orgName',
          align: 'center',
          width: '150',
          render(h, params) {
            return <span>{params.row.orgName + '/' + params.row.groupName}</span>;
          }
        },
        {
          title: '生效日期',
          key: 'startTime',
          align: 'center',
          width: '120',
          render(h, params) {
            return <span>{filterTime(params.row.startTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '承保日期',
          key: 'insureTime',
          align: 'center',
          width: '120',
          render(h, params) {
            return <span>{filterTime(params.row.insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保单状态',
          key: 'status',
          align: 'center',
          width: '100',
          render(h, params) {
            const status = params.row.status;
            if (status == 1) {
              return <span>已承保</span>;
            } else if (status == -1) {
              return <span>已退保</span>;
            } else if (status == 0) {
              return <span>已终止</span>;
            }
          }
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        }
      ];
      this.getDetail(data.id);
      this.visible = true;
    },
    changeTabs(val) {
      if (val == 3) {
        this.$refs.enroll.searchAjax();
      }
    },
    changeHesitateDate(time) {
      this.searchParams.hesitateStartTime = time[0];
      this.searchParams.hesitateEndTime = time[1];
    },
    listCallback(res) {
      this.$nextTick(() => {
        this.total = res.data?.data?.total;
        this.tableData = res.data?.data?.records;
        this.statistics = res.data?.statistics;
      });
    },
    getDetail(id) {
      this.$http({
        url: '/buz/merchantActivity/detail',
        type: 'get',
        data: {
          id
        }
      }).then(res => {
        this.formData = res.data;
        this.searchParams.name = 'salesmanName';
        this.searchParams.timeName = 'startTime';
        this.initListAjax('/buz/merchantActivity/queryPolicyListNew');
        if (res.data.productType == 1) {
          this.columns.push(
            {
              title: '回执状态',
              minWidth: 100,
              align: 'center',
              render: (h, params) => {
                const text = this.dic.RECEIPT_STATUS[params.row.receiptStatus];
                return <span>{ text || '-' }</span>;
              }
            },
            {
              title: '回访状态',
              minWidth: 100,
              align: 'center',
              render: (h, params) => {
                const text = this.dic.VERIFY_STATUS[params.row.verifyStatus];
                return <span>{ text || '-' }</span>;
              }
            },
            {
              title: '犹豫期截止日',
              align: 'center',
              key: 'hesitateDate',
              minWidth: 130,
              render(h, params) {
                let hesitateDate = params.row.hesitateDate;
                return <span>{hesitateDate ? filterTime(hesitateDate, 'YYYY-MM-DD') : '-'}</span>;
              }
            }
          );
        }
      });
    },
    setListParams(params) {
      params.activityId = this.formData.id;
      params.receiptVerifyStatus = this.formData.receiptVerifyStatus;
      if (this.nodeType == 2) {
        params.groupId = params.orgId;
        delete params.orgId;
      }
      if (params.nameValue) {
        params[params.name] = params.nameValue;
      }
      if (params.timeValue) {
        params[params.timeName] = params.timeValue;
      }
      delete params.name;
      delete params.nameValue;
      delete params.timeName;
      delete params.timeValue;
      delete params.hesitateDate;
      if (params.insureTime && params.insureTime[0]) {
        params.insureTimeStart = filterTime(params.insureTime[0], 'YYYY-MM-DD');
        params.insureTimeEnd = filterTime(params.insureTime[1], 'YYYY-MM-DD');
        delete params.insureTime;
      }
      if (params.startTime && params.startTime[0]) {
        params.startTimeStart = filterTime(params.startTime[0], 'YYYY-MM-DD');
        params.startTimeEnd = filterTime(params.startTime[1], 'YYYY-MM-DD');
        delete params.startTime;
      }
      // 回执状态
      if (params.receiptStatusNull) {
        params.receiptStatusList = [];
      }
      params.receiptStatusNull = params.receiptStatusNull ? 1 : 0;
      // 回访状态
      if (params.verifyStatusNull) {
        params.verifyStatusList = [];
      }
      params.verifyStatusNull = params.verifyStatusNull ? 1 : 0;
    },
    filterColumns() {
      // 动态处理表头
      let columns = [];
      if (this.formData.mode == 2) {
        columns = this.columns.filter(item => item.title != '活动奖励' && item.title != '活动服务费');
      } else {
        columns = this.columns;
      }
      if (this.formData.productType == 1) {
        columns = columns.filter(item => item.title != '批单号' && item.title != '方案名称');
      } else {
        columns = columns.filter(item => item.title != '交费期' && item.title != '保障期');
      }
      if (this.rowData.endorsementIsJoin == 0 && this.rowData.productType == 2) {
        columns = columns.filter(item => item.title != '批单号');
      }
      return columns;
    },
    daochu() {
      if (!this.tableData.length) {
        this.$notice.msg('暂无可导出数据');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/merchantActivity/exportPolicyList', params, 'POST');
    },
    changeOrg(data) {
      console.log(data);
      this.nodeType = data.nodeType;
    }
  }
};
</script>
<style lang="scss" scoped>
.null-radio {
  padding-left: 10px;
  line-height: 30px;
  white-space: nowrap;
}
.detail {
  /deep/.ivu-modal-body {
    padding-bottom: 30px;
  }
  /deep/.ivu-tabs-content {
    height: 600px;
    overflow-y: scroll;
  }
  .select-radio {
    .ivu-select {
      width: 120px;
      flex-shrink: 0;
      margin-right: 5px;
      /deep/.ivu-select-selection {
        border-radius: 2px;
        border-right: 1px solid #dcdee2;
      }
    }
  }
  .select-width {
    .ivu-select {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
.settlement-status {
  display: flex;
  justify-content: center;
  .tag-settled {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    color: #e3461f;
    border: 1px solid #ffc1b2;
    background: #fff5f2;
  }
  .tag-be {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    color: #35bf3f;
    border: 1px solid #abeaae;
    background: #f6fcf4;
  }
}
.name-status {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .user-box {
    display: flex;
    align-items: center;
    font-size: 12px;
    padding-left: 10px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
.addition-name {
  display: flex;
  align-items: center;
  justify-content: center;
  .fu {
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border-radius: 4px;
    background: #fff0ea;
    color: #ff7134;
    margin-right: 5px;
  }
}
.btn-item {
  bottom: auto;
  width: 260px;
  .btn-item__item {
    margin-left: 0 !important;
    margin-right: 10px;
    margin-bottom: 10px;

    &:nth-of-type(3n) {
      margin-right: 0;
    }
  }
}
</style>
